module.exports = __webpack_public_path__ + "assets/img/top_title.f2811e57.png";